import React from "react";
import { Layout, Button } from "antd";
import type { ClusterEnvItem } from "../../api";
import { LAYOUT } from "../../constants/layout";
import EnvProductSelector from "../EnvProductSelector";

interface HeaderProps {
  clusterEnvItems: ClusterEnvItem[];
  isRecording: boolean;
  selectedEnv?: string;
  onBusinessEnvChange: (business: string | undefined, env: string | undefined) => void;
  onStartRecording: () => void;
  onStopRecording: () => void;
  onShowHistory: () => void;
  onShowClusters: () => void;
  onShowReplayResults: () => void;
}

/**
 * 应用头部组件
 * @param props - 组件属性
 * @returns React 元素
 */
const Header: React.FC<HeaderProps> = ({
  clusterEnvItems,
  isRecording,
  selectedEnv,
  onBusinessEnvChange,
  onStartRecording,
  onStopRecording,
  onShowHistory,
  onShowClusters,
  onShowReplayResults,
}) => {
  return (
    <Layout.Header
      style={{
        display: "flex",
        alignItems: "center",
        padding: LAYOUT.HEADER.PADDING,
        borderBottom: `1px solid ${LAYOUT.HEADER.BORDER_COLOR}`,
      }}
    >
      <EnvProductSelector
        clusterEnvItems={clusterEnvItems}
        isRecording={isRecording}
        onChange={onBusinessEnvChange}
        onStartRecording={onStartRecording}
        onShowHistory={onShowHistory}
      />
      <Button onClick={onShowClusters} style={{ marginLeft: 8 }}>
        集群管理
      </Button>
      <Button onClick={onShowReplayResults} style={{ marginLeft: 8 }}>
        回放结果/Diff
      </Button>
      {isRecording && selectedEnv && (
        <Button danger onClick={onStopRecording} style={{ marginLeft: 8 }}>
          停止录制 ({selectedEnv})
        </Button>
      )}
    </Layout.Header>
  );
};

export default Header; 
